import Icon from "commons/components/AppIcon";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

export const adminNavigationItems = [
  {
    label: "Dashboard",
    path: "/dashboard",
    icon: "LayoutDashboard",
    tooltip: "View your dashboard and recent activities",
  },
  {
    label: "Users",
    path: "/users",
    icon: "Users",
    tooltip: "Manage users",
  },
  {
    label: "Organizations",
    path: "/organizations",
    icon: "Building2",
    tooltip: "Manage organizations",
  },
  {
    label: "Events",
    path: "/events",
    icon: "Calendar",
    tooltip: "Manage and attend networking events",
    children: [
      { label: "Create Event", path: "/event-creation" },
      { label: "Event Details", path: "/event-details" },
    ],
  },
  {
    label: "Security",
    path: "/security",
    icon: "ShieldUser",
    tooltip: "Manage security personnels",
  },
  // {
  //   label: "Meetings",
  //   path: "/meeting-scheduler",
  //   icon: "Clock",
  //   tooltip: "Schedule and manage meetings",
  // },
  // {
  //   label: "Business Activities",
  //   path: "/business-activity",
  //   icon: "Briefcase",
  //   tooltip: "Schedule and manage meetings",
  // },
  // {
  //   label: "Announcement",
  //   path: "/announcement",
  //   icon: "Megaphone",
  //   tooltip: "Schedule and manage meetings",
  // },
];

const AdminSideNavigation = ({ onItemClick, isMobile = false }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const isActiveRoute = (path) =>
    path === "/dashboard"
      ? location.pathname === "/dashboard"
      : location.pathname.startsWith(path);

  return (
    <aside className="hidden lg:flex fixed top-[60px] left-0 w-[210px] h-[calc(100vh-60px)] bg-white border-r border-gray-200 shadow-lg flex-col py-7 px-4 z-[20]">
      <nav className="flex flex-col gap-4 overflow-y-auto">
        {adminNavigationItems?.map((item) => (
          <button
            key={item.path}
            onClick={() => {
              navigate(item.path);
              if (onItemClick) onItemClick();
            }}
            className={`flex items-center px-3 py-2 rounded-md text-sm font-medium transition-colors ${
              isActiveRoute(item.path)
                ? "bg-primary/10 text-primary"
                : "text-gray-700 hover:bg-gray-100"
            }`}
            title={item.tooltip}
          >
            <Icon name={item.icon} size={18} />
            <span className="ml-2">{item.label}</span>
          </button>
        ))}
      </nav>
    </aside>
  );
};

export default AdminSideNavigation;
